import React, { useState } from "react";
import classes from "./Login.module.css";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Seo, Avatar, InvoiceCardBanner } from "@components";
import { FormFeedback } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import CryptoJS from "crypto-js";

/** Redux **/
import { login } from "@store/pendingInvoices";
import { useDispatch, useSelector } from "react-redux";

/** Third Party **/
import { Config } from "@config/config";
import { NavLink, useNavigate, Navigate } from "react-router-dom";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [encryptedData, setEncryptedData] = useState({
    civilNumber: null,
    phoneNumber: null,
  });
  const { data, loading, success } = useSelector(
    (state) => state.pendingInvoices.login
  );

  const schema = yup
    .object({
      // phoneNumber: yup.string(),
      // .required(t("Validations.phone-required"))
      // .min(3, t("Validations.phone-too-short")),
      civilNo: yup.string(),
      password: yup.string().required(t("Validations.password-required")),
    })
    .required();

  const defaultValues = {
    phoneNumber: "", // 51115655
    civilNo: "",
  };

  const {
    setError,
    clearErrors,
    reset,
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const onSubmit = async (data) => {
    // const civilNumber = CryptoJS.AES.encrypt(
    //   JSON.stringify(data?.civilNo),
    //   secretPass
    // ).toString();

    // const phoneNumber = CryptoJS.AES.encrypt(
    //   JSON.stringify(data?.phoneNumber),
    //   secretPass
    // ).toString();

    dispatch(login(data))
      .then((res) => {
        if (res?.payload?.status === 200 || res?.payload?.status === 201) {
          reset();
          // navigate("/pending-invoices");
        }
      })
      .catch();
  };

  return (
    <>
      <Seo title={`${Config.name} | ${t("login")}`} />
      <div className={`${classes.authContainer}`}>
        <div className="screen-1">
          <Avatar src={Config?.logo?.default} className="login-logo" />
          <form className="mt-2" onSubmit={handleSubmit(onSubmit)}>
            <div className={`input-box`}>
              <Controller
                name="civilNo"
                control={control}
                render={({ field }) => (
                  <div className="input-box">
                    <label for="civilNo">{t("civilNumberOrPhoneNumber")}</label>
                    <div className="form-group-input">
                      <input
                        id="civilNo"
                        {...register("civilNo")}
                        {...field}
                        placeholder="12345678"
                        invalid={errors.civilNo && true}
                      />
                    </div>
                  </div>
                )}
              />
              {errors.civilNo && (
                <FormFeedback>{errors.civilNo?.message}</FormFeedback>
              )}
            </div>

            <div className={`input-box`}>
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <div className="input-box">
                    <label for="password">{t("password")}</label>
                    <div className="form-group-input">
                      <input
                        type="password"
                        id="password"
                        {...register("password")}
                        {...field}
                        placeholder={t("password")}
                        invalid={errors.password && true}
                      />
                    </div>
                  </div>
                )}
              />
              {errors.password && (
                <FormFeedback>{errors.password?.message}</FormFeedback>
              )}
            </div>

            {/* <div className={`input-box`}>
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field }) => (
                    <div className="input-box">
                      <label for="phoneNumber">
                        {t("phoneNumberOptional")}
                      </label>
                      <div className="form-group-input">
                        <input
                          id="phoneNumber"
                          {...register("phoneNumber")}
                          {...field}
                          placeholder="+965 123 4567"
                          invalid={errors.phoneNumber && true}
                        />
                      </div>
                    </div>
                  )}
                />
                {errors.phoneNumber && (
                  <FormFeedback>{errors.phoneNumber?.message}</FormFeedback>
                )}
              </div> */}

            {/* <div className={`input-box`}>
              <Controller
                name="phoneNumber"
                control={control}
                render={({ field }) => (
                  <div className="input-box">
                    <label for="phoneNumber">{t("phoneNumberOptional")}</label>
                    <div className="form-group-input">
                      <PhoneInput
                        helperText={
                          errors?.phoneNumber
                            ? errors?.phoneNumber.message
                            : null
                        }
                        error={!!errors?.phoneNumber}
                        country={"kw"}
                        {...register("phoneNumber")}
                        {...field}
                        className={"phone-number-container"}
                      />
                    </div>
                  </div>
                )}
              />
              {errors.phoneNumber && (
                <FormFeedback>{errors.phoneNumber?.message}</FormFeedback>
              )}
            </div> */}

            <button
              disabled={loading}
              type="submit"
              className="btn-primary w-100">
              {loading ? t("loading") : t("view")}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
